<template>
  <div v-if="files">
    <!-- 상태가 신청이면서 업로드된 파일 없는 경우 -->
    <RequestFileUpload
      v-if="request.status === 'init' && files?.length < 1"
      :uuid="uuid"
      @upload="uploadFirst"
    />

    <!-- 업로드된 파일 있는 경우 -->
    <v-expansion-panels v-else-if="files?.length > 0" :value="openPanel ? 0 : null">
      <v-expansion-panel class="rounded-4">
        <v-expansion-panel-header style="height: 64px" class="font--m-3">
          증빙 서류
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list two-line>
            <template v-for="(item, index) in files">
              <v-divider :key="index"></v-divider>
              <v-list-item :key="index + '-item'" target="_blank" :href="item.fileUrl">
                <v-list-item-avatar tile>
                  <v-icon v-if="extractFileExtension(item.file) === 'pdf'" large color="#f40f02">
                    mdi-file-pdf-box
                  </v-icon>
                  <v-img v-else-if="isImageFile(item.file)" contain :src="item.fileUrl"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ extractFileName(item.file) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.created | moment('YYYY년 MM월 DD일 HH:mm') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>

          <!-- 신청 상태인경우 파일 추가 가능 -->
          <RequestFileAppend v-if="request.status === 'init'" :uuid="uuid" @upload="fetchData" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { extractFileExtension, isImageFile, extractFileName } from '@/util'

export default {
  props: {
    uuid: {
      Type: String,
      required: true,
    },
    request: {
      Type: Object,
      required: true,
    },
  },
  components: {
    RequestFileUpload: () => import('@/components/credit-pay/request/detail/RequestFileUpload.vue'),
    RequestFileAppend: () => import('@/components/credit-pay/request/detail/RequestFileAppend.vue'),
  },
  data() {
    return {
      files: null,
      openPanel: true,
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      const { data } = await this.$defaultApi.getCreditPaysRequestFiles(this.uuid)
      this.files = data
    },
    async uploadFirst() {
      await this.fetchData()
      this.openPanel = true
    },
    extractFileExtension,
    isImageFile,
    extractFileName,
  },
}
</script>

<style lang="scss" scoped></style>
